import React from "react";
import "../styles/reader.css";
const UP = 38;
const DOWN = 40;
class Reader extends React.Component {
  state = {
    lineNumber: 0
  };
  componentDidMount() {
    if (this.content) {
      this.content.focus();
    }
  }
  handleKeyPress = e => {
    e.preventDefault();
    const { lineNumber } = this.state;
    const parentHeight = this.getHeight();
    const lineHeight = this.getLineHeight();
    const marginTop = lineHeight * lineNumber;
    switch (e.keyCode) {
      case UP:
        lineNumber > 0 &&
          this.setState({
            lineNumber: lineNumber - 1
          });
        break;
      case DOWN:
        marginTop + lineHeight < parentHeight &&
          this.setState({
            lineNumber: lineNumber + 1
          });
        break;
      default:
        break;
    }
  };
  getHeight = () => {
    if (this.content) {
      return parseInt(this.content.offsetHeight, 10);
    }
    return 0;
  };
  getLineHeight = () => {
    if (this.content) {
      return parseInt(
        window
          .getComputedStyle(this.content.firstElementChild)
          .lineHeight.replace("px", ""),
        10
      );
    }
    return 0;
  };
  render() {
    const { lineNumber } = this.state;
    const { content } = this.props;
    const lineHeight = this.getLineHeight();
    return (
      <React.Fragment>
        <div
          className="reader-line-cursor"
          style={{
            marginTop: `${lineHeight * lineNumber}px`
          }}
        />
        <div
          tabIndex={0}
          ref={elem => (this.content = elem)}
          onKeyDown={this.handleKeyPress}
          dangerouslySetInnerHTML={{ __html: content }}
          className="reader-content"
        />
      </React.Fragment>
    );
  }
}

export default Reader;



// WEBPACK FOOTER //
// ./src/components/Reader.js